export const basesUrl = {
    products: 'produtos',
    productsByCategory: 'produtos/produtosporcategoria',
    termsOfUse: 'termos-de-uso',
    privacyPolicies: 'politica-de-privacidade'
}
